<template>
    <div :class="$style['confirm-tab']">
        <div :class="$style['confirm-tab__title']">
            {{ tab.noRes }} {{ complex.noRes }}
        </div>

        <div :class="$style['confirm-tab__text']">
            Показать программы для всех комплексов?
        </div>

        <div :class="$style['confirm-tab__buttons']">
            <div :class="$style['confirm-tab__button-yes']">
                <Button @click="$emit('success', tab)">Да, покажите</Button>
            </div>

            <div :class="$style['confirm-tab__button-no']">
                <button class="link-icon" @click="$emit('error')">
                    Нет, остаться на&nbsp;этой странице
                    <span class="link-icon__icon">
                        <svg width="12" height="12" class="link-icon__icon-close">
                            <use xlink:href="/webicons/sprite.svg#i-close-link"></use>
                        </svg>
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from '../Button/Button';

    export default {
        props: ['tab', 'complex'],
        components: {
            Button
        }
    }
</script>

<style lang="scss" module>
    @import "./ConfirmTab";
</style>
